import { useMemo } from 'react'

import { VisualAudienceExtended } from 'core/components/shared/ui/VisualAudienceExtended'
import { useParentRequest } from 'onboarding/hooks/useParentRequest'
import { useRequest } from 'onboarding/hooks/useRequest'

import { contactFields } from './configs'
import { ContractValidate } from './ContractValidate'
import { IContractValidateWidgetProps } from './models'

import styles from './ContractValidate.module.scss'

const partnerFields = [
  {
    field: 'TerritoryExtensionConducted',
    JSXLabel: (
      <p className={styles.jsxLabel}>
        <span className={styles.jsxLabel__bold}>Territory Extension Conducted</span> (Applies only
        for Australia and New Zealand)
      </p>
    ),
    type: 'boolean',
  },
  { field: 'TerritoryExtensionsList', label: 'Territory Extensions List' },
  {
    field: 'TerritoryExtensionsBusinessJustification',
    label: 'Territory Extensions Business Justification',
  },
]
export const ContractValidateApj = (props: IContractValidateWidgetProps) => {
  const { req } = useRequest(props.requestId || '')
  const { parentRequest } = useParentRequest(req.Parent)
  const request = useMemo(() => parentRequest ?? req, [req, parentRequest])

  return (
    <VisualAudienceExtended
      component={ContractValidate}
      write={props.audienceSettings}
      metrics={props.metrics}
      disabled={props.disabled}
      PartnerID={props.partnerID || request.PartnerId}
      partnerFields={partnerFields}
      contactFields={contactFields}
      RequestId={request.EntryId?.toString()}
      flexWidth={props.flexWidth}
      showEndUserInfo
      appSource={props.appSource}
    />
  )
}
